var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 17.3333H3.33333C2.04417 17.3333 1 18.3775 1 19.6667V26.6667C1 27.9558 2.04417 29 3.33333 29H10.3333C11.6225 29 12.6667 27.9558 12.6667 26.6667V19.6667C12.6667 18.3775 11.6225 17.3333 10.3333 17.3333ZM26.6667 17.3333H19.6667C18.3775 17.3333 17.3333 18.3775 17.3333 19.6667V26.6667C17.3333 27.9558 18.3775 29 19.6667 29H26.6667C27.9558 29 29 27.9558 29 26.6667V19.6667C29 18.3775 27.9558 17.3333 26.6667 17.3333ZM10.3333 1H3.33333C2.04417 1 1 2.04417 1 3.33333V10.3333C1 11.6225 2.04417 12.6667 3.33333 12.6667H10.3333C11.6225 12.6667 12.6667 11.6225 12.6667 10.3333V3.33333C12.6667 2.04417 11.6225 1 10.3333 1ZM26.6667 1H19.6667C18.3775 1 17.3333 2.04417 17.3333 3.33333V10.3333C17.3333 11.6225 18.3775 12.6667 19.6667 12.6667H26.6667C27.9558 12.6667 29 11.6225 29 10.3333V3.33333C29 2.04417 27.9558 1 26.6667 1Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIcon);
export default __webpack_public_path__ + "static/media/GridIcon.b9cce998f01541633b79812c0ee9bd5f.svg";
export { ForwardRef as ReactComponent };